import { useState } from "react";
import { TileLayer, useMap, useMapEvents } from "react-leaflet";

const BaseMapLayerProvider = ({ notifyAboutCurrentLayer }) => {
	const map = useMap();
	const [zoom, setZoom] = useState(map._zoom);

	const notifyLayer = () => {
		//Note that OSM layer can be added through layercontrol, too
		const isOSMLayerAdded = Object.values(map._layers).find(layer => layer._url && layer._url.includes('openstreetmap')) !== undefined;
		notifyAboutCurrentLayer(isOSMLayerAdded ? 'OSM' : 'DARE');
	};
	
	const mapEvents = useMapEvents({
		zoomend: (e) => {
			setZoom(mapEvents.getZoom());

			setTimeout(notifyLayer, 10);
		},
		layeradd: (e) => {
			setTimeout(notifyLayer, 10);
		},
		layerremove: (e) => {
			setTimeout(notifyLayer, 10);
		},
	});

	return zoom > 11 ?
		<TileLayer
			key="OSM"
			attribution=''
			url={process.env.REACT_APP_CUSTOM_CDN_URL ? process.env.REACT_APP_CUSTOM_CDN_URL+"/osm/{z}/{x}/{y}.png" : "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"}
		/>
	: <TileLayer
		key="DARE"
		attribution=''
		url={process.env.REACT_APP_CUSTOM_CDN_URL ? process.env.REACT_APP_CUSTOM_CDN_URL+"/dare/{z}/{x}/{y}.png" : "https://dh.gu.se/tiles/imperium/{z}/{x}/{y}.png"}
	/>;
}

export default BaseMapLayerProvider;